import React from 'react';
import TeamsTicketsTabView from './Tickets/TeamsTicketsTabView';

const TeamsTickets = props => <TeamsTicketsTabView {...props} />;

export default TeamsTickets;